module.exports = __webpack_public_path__ + "static/media/chevron-down-solid.7d1c6c08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/chevron-down-solid.svg
// module id = 37
// module chunks = 0